/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IResponsePayload, useApiRequest } from '../../../../../hooks/useApiRequest';
import { URLS } from '../../../../../constants/urls.constants';
import { stopLoading } from '../../../../../store/modules/loading';
import { setAlert } from '../../../../../store/modules/snackbar';
import { useTableCustom } from '../../../../../hooks/useTableCustom';
import { areaViewLvlAdapter } from '../adapters/area-view-lvl-adapter';
import { RootState } from '../../../../../store';
import { SupervisionHistoryContext } from '../../../contexts/useSupervisionHistoryContext';

export function useFunctionalRoutines(handleView: any) {
	const dispatch = useDispatch();
	const { page, rowsPerPage } = useSelector((state: RootState) => state.pageTable);
	const { dataSelect, setDataSelect } = useContext(SupervisionHistoryContext);

	const {
		data: dataFunctionalRoutines,
		setData: setFunctionalRoutines,
		handleGetFiltersParams,
	} = useTableCustom<Object>({
		countRows: 0,
		rows: [],
		sort: { col: '', order: '' },
		pagination: page,
		rowsSelect: [],
		rowsPerPage: rowsPerPage,
		advancedFilter: '',
		activeAdvanceFilter: false,
		filterCustom: {},
	});

	const {
		execute: executeFunctionalRoutines,
		status,
		value,
	} = useApiRequest<unknown, IResponsePayload<any>>({
		path: URLS.SUPERVISION_HISTORY.HISTORY_BY_FUNCTIONAL_ROUTINES,
		method: 'GET',
	});

	useEffect(() => {
		if (status === 'success') {
			setFunctionalRoutines({
				...dataFunctionalRoutines,
				countRows: value?.totalRecords || 0,
				rows: areaViewLvlAdapter(value?.data || [], handleView),
				sort: {
					col: '',
					order: 'ASC',
				},
			});
			dispatch(stopLoading());
		} else if (status === 'error') {
			dispatch(
				setAlert({
					show: true,
					message: 'Ocurrió un error al consultar la información.',
					severity: 'error',
				})
			);
			dispatch(stopLoading());
		}
	}, [status]);

	return {
		dataFunctionalRoutines,
		setFunctionalRoutines,
		executeFunctionalRoutines,
		dataSelect,
		setDataSelect,
		handleGetFiltersParams,
	};
}
